import React from 'react';
import styled from 'styled-components';
import { compose, maxWidth, space, variant } from 'styled-system'; // Imports maxWidth prop without entire layout system

import type {
  FontWeightProps,
  TextAlignProps,
  TextColorProps,
  ThemeParagraphSizes,
} from '@rover/kibble/styles';
import { DSTokenMap, fontWeight, textAlign, textColor } from '@rover/kibble/styles';

import Box from '../Box';
import type { SpacingSystemProps } from '../styledSystemPropTypes';

export type Props = SpacingSystemProps &
  TextAlignProps &
  TextColorProps &
  FontWeightProps & {
    size?: ThemeParagraphSizes;
    children: any;
    maxWidth?: string;
  };
const StyledParagraph = styled(Box)(
  // Resets values in case of global styles
  {
    padding: '0',
    margin: '0',
    border: '0 none',
  },
  variant({
    prop: 'size',
    variants: {
      // TODO: move these styles to Style Dictionary to format into theme.ts
      100: {
        fontSize: DSTokenMap.PARAGRAPH_100_FONT_SIZE,
        lineHeight: DSTokenMap.PARAGRAPH_100_LINE_HEIGHT,
        marginBottom: DSTokenMap.PARAGRAPH_100_MARGIN_BOTTOM,
      },
      200: {
        fontSize: DSTokenMap.PARAGRAPH_200_FONT_SIZE,
        lineHeight: DSTokenMap.PARAGRAPH_200_LINE_HEIGHT,
        marginBottom: DSTokenMap.PARAGRAPH_200_MARGIN_BOTTOM,
      },
      300: {
        fontSize: DSTokenMap.PARAGRAPH_300_FONT_SIZE,
        lineHeight: DSTokenMap.PARAGRAPH_300_LINE_HEIGHT,
        marginBottom: DSTokenMap.PARAGRAPH_300_MARGIN_BOTTOM,
      },
    },
  }),
  compose(textAlign, textColor, fontWeight, space, maxWidth) // Apply last to avoid being overwritten by resets and variant styles
);

function Paragraph(props: Props): any {
  return <StyledParagraph {...props} as="p" />;
}

Paragraph.defaultProps = {
  size: '200',
  maxWidth: '640px', // reasoning behind this default is at http://www.rover.com/storybook/?path=/docs/kibble-components-paragraph--default-story#length
};

export default Paragraph;



// WEBPACK FOOTER //
// ../kibble/components/Paragraph/Paragraph.tsx